module.exports = __webpack_public_path__ + "img/puntosdeventa.fe2057c0.jpeg";